import React from 'react';
import { Link } from 'react-router-dom';
import './Buttons.css';

export const Button = ({ children, className, onClick, disabled, submitting }) => {
  return (
    <button onClick={onClick} className={className} type="submit" disabled={disabled}>
      {submitting ? <div className="spinnerItem" /> : children}
    </button>
  );
};

export const CancelButton = ({ text, onClick, className }) => (
  <button onClick={onClick} className={`cancelButton ${className}`} type="button">
    {text}
  </button>
);

export const SubmitButton = ({
  text = 'Submit',
  onClick,
  isDisabled,
  mockDisabled,
  className = '',
  submitting,
  modernLayout,
  isObstructed = false,
}) => {
  const submittingClassName = submitting ? 'buttonSubmitting' : '';
  const mockDisabledClassName = mockDisabled ? 'buttonMockDisabled' : '';

  return (
    <Button
      onClick={onClick}
      className={`formSubmit${isObstructed ? ' keyboardActive' : ''}${
        modernLayout ? ' modernLayout' : ''
      } ${className} ${submittingClassName} ${mockDisabledClassName}`}
      disabled={submitting || isDisabled}
      submitting={submitting}
    >
      {text}
    </Button>
  );
};

export const LinkSubmitButton = ({
  path,
  text,
  className = '',
  submitting,
  onClick,
  modernStyle,
  inline,
  isDisabled,
}) => (
  <Link
    onClick={onClick}
    to={path}
    className={`formSubmit linkButton${modernStyle ? ' modernStyle' : ''}${inline ? ' inline' : ''} ${className}${
      isDisabled ? ' disabled' : ''
    }`}
  >
    {submitting ? <div className="spinnerItem" /> : text}
  </Link>
);

export const StaticLinkButton = ({ path, text, className = '', onClick }) => {
  const isExternalLink = typeof path === 'string' && !!path.match(/http/i);
  if (isExternalLink) {
    return (
      <a href={path} onClick={onClick} className={`linkButton ${className}`}>
        <SubmitButton text={text} />
      </a>
    );
  }

  return (
    <Link to={{ pathname: path, state: { from: path } }} onClick={onClick} className={`linkButton ${className}`}>
      <SubmitButton text={text} />
    </Link>
  );
};

export const SmallButton = ({ text = 'Submit', onClick, isDisabled, submitting }) => (
  <button onClick={onClick} className="smallButton" type="submit" disabled={isDisabled}>
    {submitting ? <div className="spinnerItem" /> : text}
  </button>
);

export const PillButton = ({
  text = 'Submit',
  type = null,
  modernLayout,
  className = '',
  onClick,
  isDisabled,
  submitting,
}) => (
  <button
    onClick={onClick}
    className={`pillButton ${className}${modernLayout ? ' modernLayout' : ''}`}
    {...(type && { type })}
    disabled={isDisabled}
  >
    {submitting ? <div className="spinnerItem" /> : text}
  </button>
);
